import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from "@angular/core";

@Directive({
  selector: "[infiniteScrollAnchor]",
})
export class InfiniteScrollAnchorDirective implements AfterViewInit, OnDestroy {
  @Output() loadMore = new EventEmitter<void>();
  @Input() infiniteScrollLoading = false;
  @Input() infiniteScrollEop = false;
  private observer?: IntersectionObserver;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.infiniteScrollLoading && !this.infiniteScrollEop) {
          this.loadMore.emit();
        }
      },
      { root: null, rootMargin: "300px 0px", threshold: 0 },
    );
    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
